<template>
	<div class="header">

		<div>
			<post-smtp-img
				:src="image_url"
			></post-smtp-img>
		</div>
		<div>
			<post-smtp-settings
				:buttons="[
					{
						icon: get_image_url( 'bell.svg' ),
						action: 'bell',
					},
					{
						icon: get_image_url( 'settings.svg' ),
						action: 'setting',
					},
				]"
			></post-smtp-settings>
		</div>

	</div>
</template>

<script>
export default {
	name: 'PostSMTPHeader',

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
	} ),

	computed: {
		image_url() {
			return this.$parent.$parent.plugin_dir_url + 'assets/images/logo.png';
		}
	},

	methods: {
		get_image_url( img ) {
			return this.plugin_dir_url + 'assets/images/' + img;
		}
	}
}
</script>

<style scoped>
.header {
	height: 84px;
	flex-shrink: 0;
	background: #ffffff;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 40px;
}
</style>